import { apiClient, unwrap } from '@/lib/api-client';
import type { ApiSuccess } from '@/types/api';
import type { FileAsset } from '@/services/file.service';

/** Bentuk yang dipakai form Super Admin — string kosong berarti "pakai bawaan". */
export interface PlatformBranding {
  logoUrl: string;
  faviconUrl: string;
}

/** Bentuk yang dijawab endpoint publik, yang memakai null alih-alih string kosong. */
export interface PublicPlatformBranding {
  logoUrl: string | null;
  faviconUrl: string | null;
}

export const platformBrandingService = {
  get(): Promise<PlatformBranding> {
    return unwrap(apiClient.get<ApiSuccess<PlatformBranding>>('/admin/platform-branding'));
  },

  save(payload: PlatformBranding): Promise<PlatformBranding> {
    return unwrap(apiClient.put<ApiSuccess<PlatformBranding>>('/admin/platform-branding', payload));
  },

  /**
   * Berkas logo/favicon tidak lewat POST /files: jalur itu membebankan
   * berkasnya ke kuota penyimpanan sebuah tenant, dan Super Admin tidak
   * punya tenant.
   */
  uploadAsset(file: File): Promise<FileAsset> {
    const formData = new FormData();
    formData.append('file', file);

    return unwrap(
      apiClient.post<ApiSuccess<FileAsset>>('/admin/platform-branding/asset', formData, {
        headers: { 'Content-Type': undefined },
      }),
    );
  },

  getPublic(): Promise<PublicPlatformBranding> {
    return unwrap(
      apiClient.get<ApiSuccess<PublicPlatformBranding>>('/public/platform-branding'),
    );
  },
};
